/**
 * Created by liuxsen on 2017/10/13.
 */
import axios from 'axios'

let instance = axios.create();
const postHttp = function (url, param) {
    // instance.defaults.headers.common['token'] = localStorage.getItem("ra_token");
// Add a request interceptor
    if (url != 'login/login' && url != 'login/identify') {
        instance.defaults.headers.common['log_entid'] = localStorage.getItem('log_entid')
        instance.defaults.headers.common['log_phone'] = localStorage.getItem('log_phone')
        instance.defaults.headers.common['_log_user_type'] = localStorage.getItem('log_utype')
    }
    instance.interceptors.request.use(function (config) {

        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });

// Add a response interceptor
    instance.interceptors.response.use(function (response) {
        // Do something with response data

        return response;
    }, function (error) {
        // Do something with response error
        return Promise.reject(error);
    });
    return instance.post(url, param);
};

export function getHttp(url) {
    if (url != 'login/login' && url != 'login/identify') {
        instance.defaults.headers.common['log_entid'] = localStorage.getItem('log_entid')
        instance.defaults.headers.common['log_phone'] = localStorage.getItem('log_phone')
        instance.defaults.headers.common['_log_user_type'] = localStorage.getItem('log_utype')
    }
    instance.interceptors.request.use(function (config) {

        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });

// Add a response interceptor
    instance.interceptors.response.use(function (response) {
        // Do something with response data

        return response;
    }, function (error) {
        // Do something with response error
        return Promise.reject(error);
    });
    return instance.get(url);
}

export default postHttp;



// WEBPACK FOOTER //
// ./src/plugin/extendFn/postHttp.js